import { IStore } from 'apps/carrier/utils/reducers'

export const selectCarrierId = ({ carrier }: IStore): string | undefined =>
  carrier.carrierDetails?.id

export const selectCarrierName = ({ carrier }: IStore): string | undefined =>
  carrier.carrierDetails?.legalName

export const selectCarrierState = ({ carrier }: IStore): string | undefined =>
  carrier.carrierDetails?.state
